var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHlStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67385 8.76898V14.7564C5.67247 15.0427 5.74928 15.3229 5.89429 15.5601C6.0393 15.7975 6.24579 15.9811 6.48673 16.087L12.0839 18.3679C12.3916 18.5048 12.7354 18.5048 13.0432 18.3679L18.6403 16.087C18.8811 15.9811 19.0874 15.7973 19.2321 15.5599C19.3767 15.3227 19.4532 15.0425 19.4515 14.7564V8.76898",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.33 1.64964L0.810791 6.19491L12.3856 10.2507C12.7597 10.3818 13.1677 10.3818 13.5418 10.2507L24.0246 6.57757C24.1077 6.54826 24.1801 6.49466 24.2317 6.42347C24.2834 6.35228 24.3121 6.26731 24.3138 6.17957C24.3154 6.09201 24.2902 6.00583 24.2413 5.93274C24.1925 5.85983 24.1223 5.8033 24.0402 5.7709L13.6044 1.64964C13.195 1.48934 12.7394 1.48934 12.33 1.64964Z",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62079 5.93921V11.231",
    stroke: "#737373",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlStudents);
export default __webpack_public_path__ + "static/media/HL_Students.b5e590f06fb037722ba6edac6bd08fd7.svg";
export { ForwardRef as ReactComponent };